import React, { useState, useCallback } from 'react';
import debounce from 'lodash.debounce';

import { FeltTypeTextareaProps } from './felttypetextarea.definition';

export const FeltTypeTextarea = (props: FeltTypeTextareaProps) => {
	const [error, setError] = useState(false);

	const {
		id,
		label,
		name,
		value,
		maxLength,
		required = false,
		errorMessage = 'Dette felt er påkrævet.'
	} = props;

	const checkIfError = (elm: any) => {
		const { value } = elm;

		if (!required) {
			return;
		}

		if (value.length > 0) {
			setError(false);
		} else {
			setError(true);
		}
	};

	const onChange = (event: any) => {
		props.onChange(event.target.value);
	};

	const onKeyUp = useCallback(
		debounce((elm: any) => {
			checkIfError(elm);
		}, 300),
		[]
	);

	return (
		<div
			className="begTextarea"
			data-validation={ required ? true : false }
		>
			{ label && <label htmlFor={ id }>{ label }</label> }
			<textarea
				id={ id }
				name={ name }
				onChange={ onChange }
				onBlur={ e => checkIfError(e.target) }
				onKeyUp={ e => onKeyUp(e.target) }
				key={ id }
				value={ value }
				maxLength={ maxLength }
			/>
			{ required && (
				<small className={ `error-text ${ error ? 'error-text--isactive' : '' }` }>
					<span className="open">{ errorMessage }</span>
				</small>
			) }
		</div>
	);
};

export default FeltTypeTextarea;